export enum NodeTransformer {
    BlockStatementControlFlowTransformer = 'BlockStatementControlFlowTransformer',
    ClassDeclarationTransformer = 'ClassDeclarationTransformer',
    CommentsTransformer = 'CommentsTransformer',
    CustomNodesTransformer = 'CustomNodesTransformer',
    DeadCodeInjectionTransformer = 'DeadCodeInjectionTransformer',
    EvalCallExpressionTransformer = 'EvalCallExpressionTransformer',
    FunctionControlFlowTransformer = 'FunctionControlFlowTransformer',
    CatchClauseTransformer = 'CatchClauseTransformer',
    FunctionDeclarationTransformer = 'FunctionDeclarationTransformer',
    FunctionTransformer = 'FunctionTransformer',
    ImportDeclarationTransformer = 'ImportDeclarationTransformer',
    LabeledStatementTransformer = 'LabeledStatementTransformer',
    LiteralTransformer = 'LiteralTransformer',
    MemberExpressionTransformer = 'MemberExpressionTransformer',
    MetadataTransformer = 'MetadataTransformer',
    MethodDefinitionTransformer = 'MethodDefinitionTransformer',
    ObfuscatingGuardsTransformer = 'ObfuscatingGuardsTransformer',
    ObjectExpressionKeysTransformer = 'ObjectExpressionKeysTransformer',
    ObjectExpressionTransformer = 'ObjectExpressionTransformer',
    ParentificationTransformer = 'ParentificationTransformer',
    TemplateLiteralTransformer = 'TemplateLiteralTransformer',
    VariableDeclarationTransformer = 'VariableDeclarationTransformer'
}
